import React from 'react';
import { DeepMap, FieldError } from 'react-hook-form';
import { Field as FormikField } from 'formik';

import styles from './styles.module.scss';

export type Props = {
  name: string;
  inputRef?: ((instance: HTMLSelectElement | null) => void) | React.RefObject<HTMLSelectElement>;
  label?: string;
  errors?: DeepMap<Record<string, any>, FieldError>;
  options: Option[];
  formik?: boolean;
} & React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

const Select = ({ label, errors, inputRef, options, formik, ...props }: Props) => (
  <>
    {label ? <label htmlFor={props.name}>{label}</label> : null}
    {formik ? (
      <FormikField as="select" {...props} className={styles.select} data-testid={`${props.name}-field`}>
        {options?.map((o: Option) => (
          <option value={o.value} key={o.value} disabled={o?.disabled} data-testid={`${o.value}-option`}>
            {o.title}
          </option>
        ))}
      </FormikField>
    ) : (
      <select ref={inputRef} {...props} className={styles.select} data-testid={`${props.name}-field`}>
        {options?.map((o: Option) => (
          <option value={o.value} key={o.value} disabled={o?.disabled} data-testid={`${o.value}-option`}>
            {o.title}
          </option>
        ))}
      </select>
    )}
    {errors?.[props.name] && <p data-test-id="error">{errors[props.name].message}</p>}
  </>
);

export default Select;
